import { Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, lightGrey } from 'utils/colors';
import {
    dimensionsToAspectRatio,
    heightPercentageToDP,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 4,
    },
    logo: {
        width: Platform.select({
            web: 112,
            default: widthPercentageToDP(40, 68),
        }),
        aspectRatio: Platform.select({
            web: 1.67,
            default: dimensionsToAspectRatio(40, 27, 68, 42),
        }),
    },
    landScapeTitlePlaceholder: {
        flex: 1,
        backgroundColor: COLOR.DARK_GREY,
        justifyContent: 'center',
        maxWidth: widthPercentageToDP(66, 68, 112),
        maxHeight: heightPercentageToDP(27, 32, 32),
    },
    channelLineupTitlePlaceholder: {
        justifyContent: 'flex-start',
        maxWidth: '100%',
        paddingLeft: widthPercentageToDP(16),
    },
    landScapeTitle: {
        fontFamily: Fonts.main.bold,
        fontSize: isTabletOrWeb ? widthPercentageToDP(12) : 12,
        textAlign: 'center',
        color: lightGrey(),
    },
    channelLineupTitle: {
        fontFamily: Fonts.main.regular,
        fontSize: isTabletOrWeb ? widthPercentageToDP(14) : 14,
        textAlign: 'left',
    },
});

export default styles;
